/* eslint-disable camelcase */
import $ from "jquery";
import { capitalize } from "lodash";
import { getMetaContent } from "./meta";
import { validEmail } from "./validations";

export const errorsResponder = (errorsResponse, status) => {
  if (status === 409) return "Email address already in use";
  if (status >= 500)
    return "There was an unexpected response from the server. Please try again in a few minutes";

  const { errors, error } = JSON.parse(errorsResponse);

  if (error) return error;

  return Object.keys(errors).map((field) =>
    field !== "email" ? `${capitalize(field)} ${errors[field]}` : errors[field]
  );
};

export const loginFormComplete = (email, password) => {
  return validEmail(email) && password.trim().length > 0;
};

export const authenticate = async (url, data, callbacks = {}, session = {}) => {
  const csrfToken = getMetaContent("csrf-token");
  const { user_return_to } = session;

  try {
    const { user_root_path, user } = await $.ajax({
      url,
      type: "POST",
      dataType: "json",
      data,
      beforeSend: (request) =>
        request.setRequestHeader("X-CSRF-Token", csrfToken),
    });

    return callbacks.resolve({ user_root_path, user_return_to, user });
  } catch (error) {
    const { message, responseText, status } = error;
    const redirectPath = error.getResponseHeader("X-Redirect-Path");

    if (redirectPath) {
      window.location.href = redirectPath;
      return Promise.resolve();
    }

    return callbacks.reject({ message, responseText, status });
  }
};
